<template>
  <transition name="waiting-fade">
    <div v-show="visible" class="waiting-wrapper">
      <div class="waiting">
        <div class="k-line k-line-1"></div>
        <div class="k-line k-line-2"></div>
        <div class="k-line k-line-3"></div>
        <div class="k-line k-line-4"></div>
        <div class="k-line k-line-5"></div>
        <div class="k-line k-line-6"></div>
        <div class="k-line k-line-7"></div>
        <div class="k-line k-line-8"></div>
        <div class="text">{{text}}</div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      text: ''
    };
  }
};
</script>

<style lang="scss" scoped>
.waiting-wrapper {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.1);
  z-index: 99999;
}
.waiting {
  display: inline-block;
  width: 480px;
  height: 80px;
  padding-top: 24px;
  background-color: rgba(0, 0, 0, 0.8);
  border-radius: 4px;
  border: 1px solid #ebeef5;
  font-size: 18px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  overflow: hidden;
  backface-visibility: hidden;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.text {
  color: #fff;
  width: 100%;
  text-align: center;
  position: absolute;
  bottom: 24px;
  font-size: 14px;
}
.k-line {
  display: inline-block;
  height: 15px;
  width: 15px;
  opacity: 0;
  border-radius: 50%;
  transform: translateX(-160px);
  background-color:#4b9cdb /*#4b9cdb*/;
}
.k-line-1 {
  animation: k-loading 3.2s infinite;
  animation-delay: 0.8s;
}
.k-line-2 {
  animation: k-loading 3.2s infinite;
  animation-delay: 0.7s;
}
.k-line-3 {
  animation: k-loading 3.2s infinite;
  animation-delay: 0.6s;
}
.k-line-4 {
  animation: k-loading 3.2s infinite;
  animation-delay: 0.5s;
}
.k-line-5 {
  animation: k-loading 3.2s infinite;
  animation-delay: 0.4s;
}
.k-line-6 {
  animation: k-loading 3.2s infinite;
  animation-delay: 0.3s;
}
.k-line-7 {
  animation: k-loading 3.2s infinite;
  animation-delay: 0.2s;
}
.k-line-8 {
  animation: k-loading 3.2s infinite;
  animation-delay: 0.1s;
}
@keyframes k-loading {
  50% {
    transform: translateX(160px);
    opacity: 1;
  }
  100% {
    transform: translateX(480px);
    opacity: 0;
  }
}

.waiting-fade-enter-active {
  animation: waiting-fade-in 0.3s;
}

.waiting-fade-leave-active {
  animation: waiting-fade-out 0.3s;
}

@keyframes waiting-fade-in {
  0% {
    transform: translate3d(0, -20px, 0);
    opacity: 0;
  }
  100% {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
}

@keyframes waiting-fade-out {
  0% {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
  100% {
    transform: translate3d(0, -20px, 0);
    opacity: 0;
  }
}
</style>